import React, { FC, useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import nextId from "react-id-generator";
import { OnDidConfirmCallback } from "../Modals/CustomModal";



interface Props {
  message?: string,
  onDeleteClick: OnDidConfirmCallback,
  className?: string,
  disabled?: boolean,
  tooltipMessage?: string

  confirmButtonText?: string,
  closeButtonText?: string,
  headerText?: string
}

const defaultMessage = 'Are you sure you want to delete this?';
const defaultTooltipMsg = 'Delete';

const DeleteConfirm: FC<Props> = React.forwardRef<HTMLButtonElement, Props>(({ 
  onDeleteClick, 
  message = defaultMessage, 
  disabled, 
  className, 
  children, 
  tooltipMessage = defaultTooltipMsg,
  confirmButtonText = 'Confirm',
  closeButtonText = 'Close',
  headerText = 'Delete',
  ...others }, 
  ref) => {

  const [show, setShow] = useState(false);

  const handleOnDeleteClick = () => {
    setShow(true);
  };

  const handleOnConfirmClick = () => {
    setShow(false);
    onDeleteClick();
  };

  return (
    <>
      <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={nextId()}> {tooltipMessage} </Tooltip>}
      >
        <Button
            size="sm"
            variant="outline-danger"
            className={className}
            type="button"
            onClick={handleOnDeleteClick}
            disabled={disabled}
            ref={ref}
            {...others}
        >
          { children ?? <FaTrashAlt /> }
      </Button>
    </OverlayTrigger>
    <Modal show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{headerText}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShow(false)}>
          {closeButtonText}
        </Button>
        <Button variant="danger" onClick={handleOnConfirmClick}>
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
});

DeleteConfirm.displayName = 'DeleteConfirm';

export default DeleteConfirm;
